//
//  src/layouts/depict/marketing/unsubscribe/Unsubscribe.js
//
import React, { useState, useEffect } from 'react';
import { useLocation } from 'react-router-dom';
import { Helmet } from "react-helmet";
import Nav from "../../../../components/nav/Nav"
import Footer from "../../../../components/footer/Footer"
import M from "materialize-css/dist/js/materialize.min.js";
import './Unsubscribe.css'


//
//  marketing unsubscribe
//
const MarketingUnsubscribe = () => {
    const [email, setEmail] = useState('');
    const [success, setSuccess] = useState(false);
    const [loading, setLoading] = useState(false);
    const location = useLocation();
    const canonicalUrl = `https://jefftattooer.com${location.pathname}`.replace(/\/$/, '') || 'https://jefftattooer.com/marketing/unsubscribe';
    const ogImage = 'https://jefftattooer.com/logo512.png';
    const pageTitle = 'Unsubscribe from Marketing | Jeff Tattooer';
    const pageDescription = 'Unsubscribe from marketing emails from Jeff Tattooer. Update your email preferences and communication settings.';
    
    const structuredData = {
        "@context": "https://schema.org",
        "@type": "WebPage",
        "name": pageTitle,
        "description": pageDescription,
        "url": canonicalUrl
    };

    useEffect(() => {
        const params = new URLSearchParams(location.search);
        const emailParam = params.get('email');
        if (emailParam) {
            setEmail(emailParam);
        }
    }, [location.search]);

    useEffect(() => {
        if (email) {
            M.updateTextFields();
        }
    }, [email]);

    const handleSubmit = async (e) => {
        e.preventDefault();
        setLoading(true);
        try {
            const response = await fetch(`${process.env.REACT_APP_API_BASE}/guest/marketing`, {
                method: 'PUT',
                headers: {
                    'Content-Type': 'application/json'
                },
                body: JSON.stringify({
                    'email': email,
                    'marketing': false
                })
            });

            if (response.ok) {
                setSuccess(true);
                M.toast({ html: 'You have unsubscribed from marketing emails', classes: 'green' });
            } else {
                M.toast({ html: 'Error unsubscribing. Please try again.', classes: 'red' });
            }
        } catch (error) {
            M.toast({ html: 'Network error. Please try again.', classes: 'red' });
        } finally {
            setLoading(false);
        }
    };

    return (
        <div id="marketing-unsubscribe">
            <Helmet>
                <title>{pageTitle}</title>
                <meta name="description" content={pageDescription} />
                <link rel="canonical" href={canonicalUrl} />
                
                {/* Open Graph */}
                <meta property="og:title" content={pageTitle} />
                <meta property="og:description" content={pageDescription} />
                <meta property="og:image" content={ogImage} />
                <meta property="og:url" content={canonicalUrl} />
                <meta property="og:type" content="website" />
                <meta property="og:site_name" content="Jeff Tattooer" />
                
                {/* Twitter Card */}
                <meta name="twitter:card" content="summary_large_image" />
                <meta name="twitter:title" content={pageTitle} />
                <meta name="twitter:description" content={pageDescription} />
                <meta name="twitter:image" content={ogImage} />
            </Helmet>
            <Helmet>
                <script type="application/ld+json">{JSON.stringify(structuredData)}</script>
            </Helmet>
            <Nav />
            <div className="container">
                <main>
                    <div className="contact-choice-header">
                        <h1 className="contact-choice-title">Marketing Unsubscribe</h1>
                    </div>
                </main>
                <section>
                    <div className="unsubscribe-content">
                        <div
                            className={`unsubscribe-panel${success ? ' unsubscribe-panel--hidden' : ''}`}
                            aria-hidden={success}
                        >
                            <p className="info-text">
                                Enter your email address below to update your preferences and unsubscribe from any marketing emails.
                            </p>
                            <br />
                            <form onSubmit={handleSubmit}>
                                <div className="input-field">
                                    <input
                                        id="email"
                                        type="email"
                                        className="validate"
                                        value={email}
                                        onChange={(e) => setEmail(e.target.value)}
                                        required
                                        style={{ fontSize: '20px', padding: '16px', width: 'calc(100% - 32px)' }}
                                    />
                                    <label htmlFor="email">Email</label>
                                </div>
                                <button
                                    type="submit"
                                    className="btn waves-effect waves-light"
                                    disabled={loading}
                                    style={{ fontSize: '14px', width: '100%', height: '64px', backgroundColor: 'rgb(255, 152, 0)' }}
                                >
                                    {loading ? 'Processing...' : 'Unsubscribe'}
                                </button>
                            </form>
                            <br />
                            <div className="row">
                                <p className="info-text info-text-bottom">
                                    Once you submit your email, your unsubscribe request will be processed and you will be removed from any marketing communications lists.
                                </p>
                            </div>
                            <div className="row">
                                <p className="waiver">
                                    By submitting this form, you confirm that you have read, understood, and agreed to our <a href="/legal/terms-and-conditions/" title="terms and conditions">Terms and Conditions</a> and <a href="/legal/privacy-policy/" title="privacy policy">Privacy Policy</a>.
                                </p>
                            </div>
                        </div>
                        <div
                            className={`unsubscribe-panel unsubscribe-panel--success${success ? '' : ' unsubscribe-panel--hidden'}`}
                            aria-hidden={!success}
                        >
                            <p className="info-text">
                                Updated your preferences and removed you from marketing emails.
                                <br />
                                You can resubscribe anytime if you change your mind.
                            </p>
                            <br />
                            <div className="card-panel green lighten-4">
                                <span className="green-text text-darken-4">
                                    You have unsubscribed from marketing emails.
                                </span>
                            </div>
                            <br />
                            <p className="info-text info-text-bottom">
                                Your unsubscribe request has been processed successfully. If you have any further questions or need additional assistance, please feel free to reach out to me at <a href="mailto:jeff@jefftattooer.com" aria-label="Send email to Jeff Tattooer">jeff@jefftattooer.com</a>.
                            </p>
                        </div>
                    </div>
                </section>
            </div>
            <Footer />
        </div>


    );
};

export default MarketingUnsubscribe;

